var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2 0C0.895431 0 0 0.89543 0 2V22C0 23.1046 0.89543 24 2 24H12V14.5714H9.13125V11.1429H12V8.41071C12 5.31107 14.1498 3.62357 16.9189 3.62357C18.2437 3.62357 19.6687 3.72321 19.9998 3.76714V7.00446H17.7938C16.2873 7.00446 16.0002 7.71696 16.0002 8.76696V11.1429H19.5895L19.1207 14.5714H16.0002V24H22C23.1046 24 24 23.1046 24 22V2C24 0.895431 23.1046 0 22 0H2Z","fill":"#495057"}));
}

Facebook.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
